import {DragSource} from '@wandb/weave/common/containers/DragDropContainer';
import * as globals from '@wandb/weave/common/css/globals.styles';
import {Link} from '@wandb/weave/common/util/links';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import iconClock from '../../assets/ic-clock.svg';
import iconRunning from '../../assets/ic-running.svg';
import iconUser from '../../assets/ic-user-teal.svg';

const BREAKPOINT_TWO_COL_PX = 1200;
const BREAKPOINT_ONE_COL_PX = 900;
const BREAKPOINT_MOBILE_ONE_COL_PX = 666;

export const Grid = styled.div`
  display: grid;
  grid-gap: calc(${globals.spu} * 3.5);

  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  @media (max-width: ${BREAKPOINT_TWO_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  @media (max-width: ${BREAKPOINT_ONE_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr);
  }
  @media (max-width: ${globals.TABLET_BREAKPOINT}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  @media (max-width: ${BREAKPOINT_MOBILE_ONE_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Card = styled(Link)`
  &:nth-child(3n + 1) {
    grid-column: 1 / span 1;
  }
  &:nth-child(3n + 2) {
    grid-column: 2 / span 1;
  }
  &:nth-child(3n) {
    grid-column: 3 / span 1;
  }

  @media (max-width: ${BREAKPOINT_TWO_COL_PX}px) {
    &:nth-child(2n + 1) {
      grid-column: 1 / span 1;
    }
    &:nth-child(2n) {
      grid-column: 2 / span 1;
    }
  }
  @media (max-width: ${BREAKPOINT_ONE_COL_PX}px) {
    &:nth-child(1n) {
      grid-column: 1 / span 1;
    }
  }
  @media (max-width: ${globals.TABLET_BREAKPOINT}) {
    &:nth-child(2n + 1) {
      grid-column: 1 / span 1;
    }
    &:nth-child(2n) {
      grid-column: 2 / span 1;
    }
  }
  @media (max-width: ${BREAKPOINT_MOBILE_ONE_COL_PX}px) {
    &:nth-child(1n) {
      grid-column: 1 / span 1;
    }
  }
`;

export const CardText = styled.div`
  position: relative;
`;

const clampStyles = css`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  ${clampStyles}
  font-size: calc(${globals.fontSizeStandard} * 1.25);
`;

export const CardUser = styled.div`
  display: flex;
  align-items: center;
  font-size: calc(${globals.fontSizeStandard} * 0.875);
  margin-top: calc(${globals.spu} * 1);
`;

export const CardMeta = styled.div`
  font-size: calc(${globals.fontSizeStandard} * 0.75);
  margin-top: calc(${globals.spu} * 2);

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardMetaLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const CardMetaRight = styled.div`
  display: flex;
  align-items: center;
`;

export const UserIcon = styled.img.attrs({src: iconUser})`
  margin-right: 3px;
`;

export const RunsIcon = styled.img.attrs({src: iconRunning})`
  margin-right: 3px;
`;

export const UpdatedAtIcon = styled.img.attrs({src: iconClock})`
  margin-right: 3px;
`;

export const ClampedLine = styled.span`
  ${clampStyles};
`;

export const CardActions = styled.div`
  position: absolute;
  top: calc(${globals.spu} * 1.375);
  right: calc(${globals.spu} * 1.375);
`;

export const DragHandle = styled(Icon).attrs({name: 'drag-grip'})`
  font-size: calc(${globals.fontSizeStandard} * 1.75);
  border-radius: 50%;
  color: ${globals.gray300};
  user-select: none;
  cursor: grab;
  &&&:hover {
    background: ${globals.gray100};
    color: ${globals.black};
  }
  &:active {
    cursor: grabbing;
  }
`;

export const CardContent = styled(DragSource)`
  position: relative;
  background: ${globals.WHITE};
  color: ${globals.TEXT_PRIMARY_COLOR};
  &:hover {
    color: ${globals.TEXT_PRIMARY_COLOR};
  }

  border: 1px solid ${globals.MOON_200};
  &:hover {
    border-color: ${globals.TEAL_450};
  }
  border-radius: 8px;

  padding: calc(${globals.spu} * 1.375);

  &:hover ${DragHandle} {
    color: ${globals.MOON_600};
  }

  transition: border-color 0.3s;
`;
